import React from 'react';

const RedCircle = () => {
  return (
    <div
      style={{
        background: 'red',
        width: 8,
        height: 8,
        borderRadius: 4,
        position: 'absolute',
        top: 5,
        right: 0,
      }}
    />
  );
};

export default RedCircle;
